module.exports = {"update-required-data":{"text":"Before continuing, please fill out the following information(s):","contact-chat":"If you do not know your employee number, please contact the technical support chat for assistance.","save":"Update data","messages":{"dni-already-exists":"There is already a registered user with that identity document","user-is-underage":"You must be of legal age to register"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/views/account/update-required-data.json
// module id = 567
// module chunks = 117